'use client'

import { SEARCH_MODAL_TEST_IDS } from '@common/common-test-ids.const'

import type { SearchModalTab } from '../../search-modal.interface'

import styles from './SearchLineTabs.module.scss'

type SearchLineTabsProps = {
  tabs: readonly SearchModalTab[]
  activeTabId: string
  onTabChange: (id: string) => void
  ariaLabel?: string
}

export function SearchLineTabs({
  tabs,
  activeTabId,
  onTabChange,
  ariaLabel = 'Search categories',
}: SearchLineTabsProps) {
  return (
    <div className={styles.root} data-testid={SEARCH_MODAL_TEST_IDS.lineTabs} role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTabId

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            disabled={tab.disabled}
            className={isActive ? styles.tabActive : styles.tab}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
